import { lazy } from "react"
import { Navigate } from "react-router-dom"

const FeepaymentList = lazy(() => import('../../views/feepayments/list'))

const Feepayment = [
  {
    path: 'feepayments/list',
    element: <FeepaymentList/>
  }
]

export default Feepayment